import { Link, MultipleSelectField, Typography } from '@carto/meridian-ds/components'
import { DataExplorerTable } from 'features/data-explorer/types'
import { FormattedMessage } from 'react-intl'
import SubscriptionCard from 'features/data-observatory/ui/Subscriptions/SubscriptionCard'
import { Box } from '@mui/system'
import settings from 'settings'

interface NewExportFormProps {
  table: DataExplorerTable
  dates?: { label: string; value: string }[]
  selectedDates?: string[]
  onSelectDates: (dates: string[]) => void
}

function NewExportForm({ table, dates, selectedDates, onSelectDates }: NewExportFormProps) {
  const filterCopy = dates ? 'contentWithFilter' : 'contentWithNoFilter'

  return (
    <>
      <SubscriptionCard table={table} />
      <Box mt={3}>
        <Typography variant="body2" color="textPrimary" mb={0.5}>
          <FormattedMessage id={`data-explorer.subscription.exportDialog.${filterCopy}.title`} />
        </Typography>
        <Typography component="p" variant="caption" color="textSecondary">
          <FormattedMessage
            id={`data-explorer.subscription.exportDialog.${filterCopy}.text`}
            values={{ a: (content) => <Link href={settings.documentationUrl}>{content}</Link> }}
          />
        </Typography>
      </Box>
      {dates && (
        <MultipleSelectField
          label={<FormattedMessage id="data-explorer.subscription.exportDialog.form.select.label" />}
          options={dates}
          selectedOptions={selectedDates}
          onChange={onSelectDates}
          id="do-dates-select"
          fullWidth={false}
        />
      )}
    </>
  )
}

export default NewExportForm
